import { render, staticRenderFns } from "./EpisodesListItem.vue?vue&type=template&id=18ebff3b&scoped=true"
import script from "./EpisodesListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./EpisodesListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EpisodesListItem.vue?vue&type=style&index=0&id=18ebff3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ebff3b",
  null
  
)

export default component.exports